import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of as observableOf } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ReadingListService } from '®shared/reading-list/models';

import {
  DraftItemLoadedAction,
  DraftItemLoadingFailedAction,
  DraftItemRequestedAction,
  ItemResolverStoreActionTypes,
  PublishedItemLoadedAction,
  PublishedItemLoadingFailedAction,
  PublishedItemRequestedAction,
} from './item-resolver-store.actions';

@Injectable()
export class ItemResolverStoreEffects {
  constructor(
    private actions$: Actions,
    private readingListService: ReadingListService,
  ) {}

  fetchDraftItem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItemResolverStoreActionTypes.DRAFT_ITEM_REQUESTED),
      switchMap((action: DraftItemRequestedAction) => {
        const { itemId } = action.payload;
        return this.readingListService.getItem(itemId, true).pipe(
          map(
            item =>
              new DraftItemLoadedAction({
                itemId,
                item,
              }),
          ),
          catchError(error =>
            observableOf(
              new DraftItemLoadingFailedAction({
                itemId,
                error,
              }),
            ),
          ),
        );
      }),
    ),
  );

  fetchPublishedItem$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ItemResolverStoreActionTypes.PUBLISHED_ITEM_REQUESTED),
      switchMap((action: PublishedItemRequestedAction) => {
        const { itemId } = action.payload;
        return this.readingListService.getItem(itemId, false).pipe(
          map(
            item =>
              new PublishedItemLoadedAction({
                itemId,
                item,
              }),
          ),
          catchError(error =>
            observableOf(
              new PublishedItemLoadingFailedAction({
                itemId,
                error,
              }),
            ),
          ),
        );
      }),
    ),
  );
}
